/* MEXX Performance – scripts do tema */
(() => {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const cfg = window.MEXX || {};

  const waUrl = (msg) => `https://wa.me/${cfg.whatsapp}?text=${encodeURIComponent(msg)}`;

  /* ---------- dinheiro no formato da loja ---------- */
  function formatMoney(cents) {
    const format = cfg.moneyFormat || 'R$ {{amount_with_comma_separator}}';
    const value = Number(cents) / 100;
    const fmt = (decimals, thousands, decimal) => {
      const [int, dec] = value.toFixed(decimals).split('.');
      return int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (dec ? decimal + dec : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => ({
      amount: fmt(2, ',', '.'),
      amount_no_decimals: fmt(0, ',', '.'),
      amount_with_comma_separator: fmt(2, '.', ','),
      amount_no_decimals_with_comma_separator: fmt(0, '.', ','),
      amount_with_apostrophe_separator: fmt(2, "'", '.'),
    }[key] ?? fmt(2, '.', ',')));
  }
  // igual ao filtro money_without_trailing_zeros: R$ 1.459,00 -> R$ 1.459
  const formatPrice = (cents) => formatMoney(cents).replace(/[,.]00(?!\d)/, '');

  /* ---------- toast ---------- */
  let toastTimer;
  function toast(msg) {
    const t = $('#Toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove('is-show'), 2200);
  }

  /* ---------- menu mobile ---------- */
  const burger = $('[data-burger]');
  const nav = $('[data-nav]');
  if (burger && nav) {
    const setNav = (open) => {
      const header = $('[data-header]');
      if (header) nav.style.setProperty('--nav-top', `${header.getBoundingClientRect().bottom}px`);
      nav.classList.toggle('is-open', open);
      burger.setAttribute('aria-expanded', open);
      document.body.classList.toggle('no-scroll', open);
    };
    burger.addEventListener('click', () => setNav(!nav.classList.contains('is-open')));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') setNav(false); });
  }

  /* ---------- busca de marcas ---------- */
  $$('[data-brands]').forEach((section) => {
    const input = $('[data-brand-filter]', section);
    const empty = $('[data-brand-empty]', section);
    if (!input) return;
    input.addEventListener('input', () => {
      const q = input.value.trim().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
      let visible = 0;
      $$('.brand', section).forEach((li) => {
        const name = li.dataset.brandName.normalize('NFD').replace(/[̀-ͯ]/g, '');
        const show = !q || name.includes(q);
        li.hidden = !show;
        if (show) visible++;
      });
      if (empty) empty.hidden = visible > 0;
    });
  });

  /* ---------- formulário de orçamento → WhatsApp ---------- */
  $$('[data-wa-form]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const lines = [...new FormData(form)]
        .filter(([, v]) => String(v).trim())
        .map(([k, v]) => `*${k}:* ${v}`);
      window.open(waUrl(`Olá, MEXX! Quero um orçamento:\n\n${lines.join('\n')}`), '_blank', 'noopener');
    });
  });

  /* ---------- máscara de CNPJ ---------- */
  $$('[data-cnpj]').forEach((input) => {
    input.addEventListener('input', () => {
      const d = input.value.replace(/\D/g, '').slice(0, 14);
      input.value = d
        .replace(/^(\d{2})(\d)/, '$1.$2')
        .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
        .replace(/\.(\d{3})(\d)/, '.$1/$2')
        .replace(/(\d{4})(\d)/, '$1-$2');
    });
  });

  /* ---------- agendamento de instalação ---------- */
  $$('.booking__form form').forEach((form) => {
    const wrap = form.closest('.booking__form');
    const satMorning = wrap?.dataset.satMorning === 'true';
    const closedSunday = wrap?.dataset.closedSunday === 'true';
    const date = $('[data-booking-date]', form);
    const period = $('[data-booking-period]', form);
    const hint = $('[data-booking-hint]', form);
    const pad = (n) => String(n).padStart(2, '0');
    const today = new Date();
    if (date) date.min = `${today.getFullYear()}-${pad(today.getMonth() + 1)}-${pad(today.getDate())}`;

    const check = () => {
      if (!date || !date.value) return;
      const [y, m, d] = date.value.split('-').map(Number);
      const day = new Date(y, m - 1, d).getDay();
      const afternoon = period && [...period.options].find((o) => o.value.startsWith('Tarde'));
      let msg = '';
      date.setCustomValidity('');
      if (afternoon) afternoon.disabled = false;
      if (day === 0 && closedSunday) {
        msg = 'Não abrimos aos domingos. Escolha outro dia.';
        date.setCustomValidity(msg);
      } else if (day === 6 && satMorning && afternoon) {
        afternoon.disabled = true;
        period.value = period.options[0].value;
        msg = 'Aos sábados atendemos só pela manhã.';
      }
      if (hint) { hint.textContent = msg; hint.hidden = !msg; }
    };
    date?.addEventListener('change', check);

    // envia por e-mail (contact form) e abre o WhatsApp com o pedido preenchido
    form.addEventListener('submit', () => {
      check();
      if (!form.checkValidity()) return;
      const get = (name) => (form.elements[`contact[${name}]`]?.value || '').trim();
      const [y, m, d] = get('Data').split('-');
      const lines = [
        'Olá, MEXX! Quero agendar uma instalação:',
        '',
        `*Nome:* ${get('Nome')}`,
        `*Veículo:* ${get('Veículo')}`,
        `*Serviço:* ${get('Serviço')}`,
        get('Pedido') && `*Pedido:* ${get('Pedido')}`,
        `*Data:* ${d}/${m}/${y} – ${get('Período')}`,
        get('body') && `*Obs.:* ${get('body')}`,
      ].filter(Boolean);
      window.open(waUrl(lines.join('\n')), '_blank', 'noopener');
    });
  });

  /* ---------- carrossel de avaliações ---------- */
  $$('[data-reviews-track]').forEach((track) => {
    const panel = track.closest('.reviews-panel');
    const step = () => track.clientWidth * 0.9;
    $('[data-reviews-prev]', panel)?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    $('[data-reviews-next]', panel)?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
  });

  /* ---------- quantidade (+/−) ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    const input = $('input', btn.closest('[data-qty]'));
    const min = Number(input.min || 0);
    const step = Number(input.step) || 1;
    const max = input.max ? Number(input.max) : Infinity;
    input.value = Math.min(max, Math.max(min, Number(input.value || 0) + Number(btn.dataset.qtyStep) * step));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- auto-envio (ordenar, filtros, carrinho) ---------- */
  let submitTimer;
  document.addEventListener('change', (e) => {
    const el = e.target;
    const filterForm = el.closest('[data-filter-form]');
    if (filterForm && (el.matches('[data-autosubmit]') || el.type === 'checkbox')) {
      filterForm.requestSubmit ? filterForm.requestSubmit() : filterForm.submit();
      return;
    }
    if (el.matches('#CartForm [data-autosubmit]')) {
      clearTimeout(submitTimer);
      submitTimer = setTimeout(() => el.form.submit(), 500);
    }
  });
  // ordenar: o select fica fora do formulário de filtros (barra superior)
  $$('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const form = $('[data-filter-form]');
      const hidden = $('[data-sort-hidden]', form);
      if (hidden) hidden.value = select.value;
      form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  });

  // filtros no celular: painel lateral
  const filters = $('[data-filters]');
  const filtersOverlay = $('[data-filters-overlay]');
  const setFilters = (open) => {
    if (!filters) return;
    filters.classList.toggle('is-open', open);
    if (filtersOverlay) filtersOverlay.hidden = !open;
    document.body.classList.toggle('no-scroll', open);
  };
  $$('[data-filters-open]').forEach((b) => b.addEventListener('click', () => setFilters(true)));
  $$('[data-filters-close], [data-filters-overlay]').forEach((b) => b.addEventListener('click', () => setFilters(false)));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') setFilters(false); });

  $$('[data-filter-form]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const params = new URLSearchParams();
      for (const [k, v] of new FormData(form)) if (String(v).trim() !== '') params.append(k, v);
      window.location.search = params.toString();
    });
  });

  /* ---------- adicionar ao carrinho (AJAX) ---------- */
  async function refreshCartCount() {
    try {
      const cart = await (await fetch(cfg.routes.cart, { headers: { Accept: 'application/json' } })).json();
      $$('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
      const link = $('[data-cart-link]');
      if (link) {
        link.classList.remove('bump');
        void link.offsetWidth;
        link.classList.add('bump');
      }
    } catch (err) { /* contador atualiza no próximo carregamento */ }
  }
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('.js-add-to-cart');
    if (!form || e.submitter?.name === 'checkout') return;
    e.preventDefault();
    const buyNow = e.submitter?.hasAttribute('data-buy-now');
    const buttons = $$('[type="submit"]', form);
    buttons.forEach((b) => { b.disabled = true; });
    form.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(cfg.routes.cartAdd, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message);
      if (buyNow) {
        window.location.href = '/checkout';
        return;
      }
      toast('Produto adicionado ao carrinho');
      refreshCartCount();
    } catch (err) {
      toast(err.message || 'Não foi possível adicionar. Tente novamente.');
    } finally {
      form.removeAttribute('aria-busy');
      buttons.forEach((b) => { b.disabled = false; });
    }
  });

  /* ---------- página de produto ---------- */
  const productSection = $('[data-product-section]');
  if (productSection) {
    const product = JSON.parse($('[data-product-json]', productSection).textContent);
    const idInput = $('[data-variant-id]', productSection);
    const addBtn = $('[data-add-button]', productSection);
    const waBtn = $('[data-wa-product]', productSection);
    const mainMedia = $('[data-main-media]', productSection);
    const rulesEl = $('[data-quantity-rules]', productSection);
    const rules = rulesEl ? JSON.parse(rulesEl.textContent) : {};

    // regras de quantidade e preço por volume (catálogos B2B)
    function applyQuantityRules(variant) {
      const rule = rules[variant.id];
      const input = $('[data-qty-input]', productSection);
      if (!rule || !input) return;
      input.min = rule.min;
      input.step = rule.increment;
      if (rule.max) input.max = rule.max; else input.removeAttribute('max');
      if (Number(input.value) < rule.min) input.value = rule.min;
      const info = $('[data-qty-rules]', productSection);
      if (info) {
        const parts = [];
        if (rule.min > 1) parts.push(`Pedido mínimo: ${rule.min} un.`);
        if (rule.increment > 1) parts.push(`Múltiplos de ${rule.increment}`);
        if (rule.max) parts.push(`Máximo: ${rule.max} un.`);
        info.textContent = parts.join(' • ');
        info.hidden = !parts.length;
      }
      const breaks = $('[data-price-breaks]', productSection);
      if (breaks) {
        breaks.hidden = !rule.breaks.length;
        $('[data-price-breaks-body]', breaks).innerHTML = [{ min: rule.min, price: variant.price }, ...rule.breaks]
          .map((b) => `<tr><td>${b.min}+ un.</td><td>${formatMoney(b.price)} / un.</td></tr>`).join('');
      }
    }

    const showImage = (src, srcset) => {
      const img = $('img', mainMedia);
      if (!img || !src) return;
      img.removeAttribute('srcset');
      img.src = src;
      if (srcset) img.srcset = srcset;
    };

    $$('[data-thumb]', productSection).forEach((thumb) => {
      thumb.addEventListener('click', () => {
        $$('[data-thumb]', productSection).forEach((t) => t.classList.toggle('is-active', t === thumb));
        showImage(thumb.dataset.src, thumb.dataset.srcset);
      });
    });

    const selected = () => $$('.variants__option', productSection).map((fs) => $('input:checked', fs)?.value);

    function update() {
      const opts = selected();
      const variant = product.variants.find((v) => v.options.every((o, i) => o === opts[i]));
      opts.forEach((v, i) => {
        const label = $(`[data-option-label="${i}"]`, productSection);
        if (label) label.textContent = v;
      });
      const secondary = $('[data-add-secondary]', productSection);
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Indisponível'; }
        if (secondary) secondary.disabled = true;
        return;
      }
      if (idInput) idInput.value = variant.id;
      applyQuantityRules(variant);
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Comprar agora' : 'Esgotado';
      }
      if (secondary) secondary.disabled = !variant.available;
      const price = $('[data-price]', productSection);
      const compare = $('[data-compare-price]', productSection);
      const inst = $('[data-installment]', productSection);
      if (price) price.textContent = formatPrice(variant.price);
      const off = $('[data-discount]', productSection);
      const hasDiscount = variant.compare_at_price > variant.price;
      if (compare) {
        compare.hidden = !hasDiscount;
        compare.textContent = hasDiscount ? formatPrice(variant.compare_at_price) : '';
      }
      if (off) {
        off.hidden = !hasDiscount;
        off.textContent = hasDiscount ? `${Math.round((1 - variant.price / variant.compare_at_price) * 100)}% OFF` : '';
      }
      if (inst && cfg.installments > 1) {
        inst.textContent = `em ${cfg.installments}x ${formatMoney(Math.round(variant.price / cfg.installments))}`;
      }
      if (variant.featured_image) {
        const thumb = $(`[data-media-id="${variant.featured_media?.id}"]`, productSection);
        if (thumb) thumb.click();
        else showImage(variant.featured_image.src);
      }
      if (waBtn) {
        const msg = `${waBtn.dataset.waIntro}\n*${waBtn.dataset.productTitle}* – ${variant.title}\nValor: ${formatMoney(variant.price)}\n${waBtn.dataset.productUrl}?variant=${variant.id}\n\nMeu carro (modelo/ano): `;
        waBtn.href = waUrl(msg);
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      // marca combinações indisponíveis
      $$('.variants__option', productSection).forEach((fs, idx) => {
        $$('input', fs).forEach((input) => {
          const test = [...opts];
          test[idx] = input.value;
          const match = product.variants.find((v) => v.options.every((o, i) => o === test[i]));
          input.closest('.pill').classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }

    productSection.addEventListener('change', (e) => {
      if (e.target.matches('[data-option-index]')) update();
    });
    if ($('.variants', productSection)) update();
  }

  /* ---------- produtos relacionados ---------- */
  $$('[data-recommendations]').forEach(async (el) => {
    if (el.children.length) return;
    try {
      const html = await (await fetch(el.dataset.url)).text();
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      else el.remove();
    } catch (err) {
      el.remove();
    }
  });

  /* ---------- login: recuperar senha ---------- */
  const recover = $('#Recover');
  if (recover) {
    recover.hidden = window.location.hash !== '#recover';
    $$('[data-toggle-recover]').forEach((a) => a.addEventListener('click', (e) => {
      e.preventDefault();
      recover.hidden = !recover.hidden;
      if (!recover.hidden) $('input[type="email"]', recover)?.focus();
    }));
  }
})();
